import * as v from "valibot";

export const ComponentTypeEnum = v.picklist(["KUBELET", "CONTAINERD"]);
export type ComponentType = v.InferOutput<typeof ComponentTypeEnum>;

export const UpdateScopeEnum = v.picklist(["NewInstances", "AllInstances", "SpecificInstances"]);
export type UpdateScope = v.InferOutput<typeof UpdateScopeEnum>;

export const ArgSchema = v.object({
  Name: v.string(),
  Value: v.string(),
});
export type Arg = v.InferOutput<typeof ArgSchema>;

// request
export const RequestSchema = v.object({
  ClusterId: v.string(),
  NodePoolId: v.string(),
  ComponentType: ComponentTypeEnum,
  UpdateScope: UpdateScopeEnum,
  InstanceIds: v.optional(v.array(v.string())),
  ApplyToTemplate: v.optional(v.boolean()),
  Args: v.array(ArgSchema),
  UpdateType: v.optional(v.picklist(["RollingUpdate"])),
  BatchSize: v.optional(v.number()),
  PauseInterval: v.optional(v.string()),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response
export const DataSchema = v.object({
  NodePoolId: v.string(),
  NodePoolActivityId: v.nullish(v.string()),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
